// NPM Imports
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
// JS Imports
// Asset Imports

export default function ResellerTotalsHeaderRow() {
   const state = useQuoteContext()
   const { getString } = state

   return (
      <div className='row'>
         <h5 className='col-bhr1 col-bhr5'>
            {getString('product.ResellerTotalsHeaderRow.Header.Title')}
         </h5>
         <h5 className='col'>{getString('global.PEPM')}</h5>
         <div className='col'></div>
         <h5 className='col'>{getString('global.Total')}</h5>
      </div>
   )
}
